<div class="px-6 py-6">
  @if (infoDialog?.buttonLabel) {
  <div class="flex justify-center pb-8">
    <!-- open modal here -->
    <button
      paxButton
      type="button"
      variant="link"
      [isBusy]="isBusy"
      (click)="openDialog()"
    >
      {{infoDialog?.buttonLabel}}
    </button>
  </div>
  }
  <div class="flex flex-col">
    @if (continueButtonHint) {
    <div
      class="container order-2 mx-auto max-w-sm px-3 py-2 text-center text-sm text-gray-600 sm:py-1"
    >
      {{continueButtonHint}}
    </div>
    }

    <!-- We set min-height to reserve space for when the button is fixed on small devices. -->
    <div class="container order-2 mx-auto min-h-16 max-w-sm sm:order-1">
      <div
        class="fixed-bottom grid sm:!relative sm:gap-2"
        [ngClass]="{'sm:grid-cols-2  sm:bg-transparent [@media(max-height:_680px)]:bg-white [@media(max-height:_680px)]:shadow-[0_-5px_14px_rgba(0,0,0,0.1)]': enableSkipButton }"
      >
        <!-- Skip Button -->
        @if (enableSkipButton) {
        <button
          paxButton
          variant="basic-prune"
          [attr.data-testid]="skipButtonTestId"
          class="sm:mr-2"
          [isBusy]="isBusy"
          type="button"
          (click)="skip.emit()"
        >
          {{ skipButtonText }}
        </button>
        }

        <!-- Submit Button (Form) -->
        <div class="flex flex-col">
          <button
            paxButton
            class="shadow-[0_-5px_14px_rgba(0,0,0,0.1)] sm:shadow-none"
            variant="primary"
            [attr.data-testid]="continueButtonTestId"
            [isBusy]="isBusy"
            (click)="continue.emit()"
          >
            {{ continueButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
